<!-- Added component="filter-status" by rohinik for Task-240260  -->
<div class="row filter-type-selection-header">
  <div class="col-6"></div>
  <div class="col-6 text-right">{{ filter.statusSelection?.length || 0 }} Selected</div>
</div>
<div class="row filter-type-selection-body">
  <div class="col-6">
    <p-tree
      [value]="statuses"
      (click)="formDirty = true"
      [(selection)]="selectedStatuses"
      [propagateSelectionUp]="true"
      selectionMode="checkbox"
      (onNodeSelect)="statusNodeSelect()"
      (onNodeUnselect)="statusNodeUnSelect(true)"
    ></p-tree>
  </div>
  <div class="col-6">
    <p-tree
      class="selected-tree"
      (click)="formDirty = true"
      [value]="filter.statusSelection"
      [(selection)]="filter.statusSelection"
      selectionMode="checkbox"
      (onNodeUnselect)="statusNodeUnSelect(false)"
      emptyMessage=" "
    ></p-tree>
  </div>
</div>
<!-- p-tree does not have implementation of value control accessor the hack below implements this -->
<fieldset ngModelGroup="statusSelectionModGrp">
  <input type="hidden" [(ngModel)]="filter.statusSelection" name="statusSelectionField" #statusSelectionField="ngModel" required />
  <div class="row">
    <div class="col=12">
      <span class="help-block">
        <span *ngIf="formDirty && statusSelectionField.invalid"> Please select an option </span>
      </span>
    </div>
  </div>
</fieldset>
<!-- <div class="row">
    <div class="col=12">
      <span class="help-block">
        <span *ngIf="this.submitClicked && !this.filter.validate()">
          Please select an option
        </span>
      </span>
    </div>
  </div> -->
